import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage} from 'react-intl';

const PrintableReport = ({report, columns, start, startLabel, end, endLabel, sinceMessage, since, title}) => {
  return (
    <div>
      <div className='row well' style={{padding: '20px 0px', margin: '10px 0px'}}>
        <div className='col-sm-12'>
          <label style={{fontSize: '20px'}}>{title}</label>
        </div>
        <div className='col-sm-3'>
          <label>{startLabel ? startLabel : <FormattedMessage id="general.start.date" />}</label>
          <div> {start} </div>
        </div>
        <div className='col-sm-3'>
          <label>{endLabel ? endLabel : <FormattedMessage id="general.end.date" />}</label>
          <div> {end} </div>
        </div>
        { sinceMessage && since ? <div className='col-sm-3'>
          <label>{sinceMessage}</label>
          <div> {since} </div>
        </div> : null}
      </div>
      <table className='table-biolab table-striped'>
        <thead>
          <tr>
            {columns.map(h => <th key={h.key}>{h.name}</th>)}
          </tr>
        </thead>
        <tbody>
          {report.map((row, i) => <tr key={i}>{columns.map(h => <td key={h.key}>{row[h.key]}</td>)}</tr>)}
        </tbody>
      </table>
    </div>
  );
};

PrintableReport.propTypes = {
  report: PropTypes.any.isRequired,
  columns: PropTypes.array.isRequired,
  start: PropTypes.string.isRequired,
  end: PropTypes.string.isRequired,
  since: PropTypes.string,
  sinceMessage: PropTypes.string,
  title: PropTypes.string,
  startLabel: PropTypes.string,
  endLabel: PropTypes.string,
};

export default PrintableReport;
